import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyASsnTACyHnJK9rrUCL9aWCaGRZa9Z6z5Y",
    authDomain: "corretoramarinaide.firebaseapp.com",
    projectId: "corretoramarinaide",
    storageBucket: "corretoramarinaide.firebasestorage.app",
    messagingSenderId: "829511997310",
    appId: "1:829511997310:web:6a90ccc76a0078c7fa852f",
    measurementId: "G-1B8N3HRNR6",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
